module.exports = __webpack_public_path__ + "img/av178.d5026a75.png";